import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import redirector from "../../util/redirector";
import Button from "../common/Button";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";
import * as layoutActions from "../../actions/e-loketLayoutActions";
import { getSettings } from "../../store/configureStore";

class NietGevondenPage extends React.Component {
	constructor(props, context) {
		super(props, context, true);

		this.state = {
			routeWithAanmeldCode: props.routeWithAanmeldCode
		};
	}

	componentDidMount() {
		this.props.loadLayout('');
	}

	render() {
		const settings = getSettings();
		if (this.state.routeWithAanmeldCode) {
			return (
				<Section>
					<Fieldset>
						<div className="jumbotron">
							<h1>De gevraagde pagina werd niet gevonden.</h1>
							<br />
							Ben je een organisator van een tocht dan kan je via de website van Sport Vlaanderen je tochten beheren.
							<br />
							<a href="https://www.sport.vlaanderen/organisatoren-van-sportevenementen/ondersteuning-organisatie-toertochten/" target="blank" style={{ "color": "#006fb7" }}>https://www.sport.vlaanderen/organisatoren-van-sportevenementen/ondersteuning-organisatie-toertochten/</a>
							<br />
							<br />
							Ben je een medewerker van een sportfederatie, koepelorganisatie of gemeente moet je aanmelden via het <a href={settings.eloketUrl} target="blank" style={{ "color": "#006fb7" }}>E-loket van Sport Vlaanderen.</a>
						</div>
					</Fieldset>
				</Section>
			);
		} else {
			return (
				<Section>
					<Fieldset>
						<div className="jumbotron">
							<h1>404 pad niet gevonden.</h1>
						</div>
					</Fieldset>
					<Fieldset>
						<Button onClick={redirector.goToHome} text="Ga terug" />
					</Fieldset>
				</Section>
			);
		}
	}
}

NietGevondenPage.propTypes = {
	loadLayout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch)
	};
}
export default connect(null, mapDispatchToProps)(NietGevondenPage);
